import { FormControl, MenuItem, Select } from '@mui/material';
import React from 'react'

export default function SupSelect({ onChange, item, bankAccount }) {

  return (
    <>
      <FormControl fullWidth>
        <Select
          size='small'
          value={item?.bankListValue || ''}
          onChange={onChange}
          style={{
            fontSize: '1rem', height: 25,
            // color: true && 'black !important',
            // backgroundColor: true && 'hsl(0, 0%, 95%)',
          }}
          // disabled={true}
        >
          {bankAccount?.map((item) => (
            <MenuItem key={item?.accountNumber} value={item?.accountNumber}>
              {item?.accountNumber}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </>
  );
}
